import Vue from 'vue';

export default Vue.component('ed-icon', {
  props: ['icon', 'title', 'iconSize', 'color', 'classIcon'],
  data: () => {
    return {
      showTooltip:false,
      iconHeight:0
    }
  },
  computed: {
    _title() {
      return this.title ? this.title : '';
    },
    _iconSize(){
      return this.iconSize ? this.iconSize : '25px';
    }
  },
  mounted(){
    this.iconHeight = this.$refs.icon.getBoundingClientRect().height + 5;
  }
});
